// Why Best.jsx
import React from "react";
import { Typography, Grid, Box, Container } from "@mui/material";
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import AirplanemodeActiveIcon from "@mui/icons-material/AirplanemodeActive";
import ApartmentIcon from '@mui/icons-material/Apartment';
import ExploreIcon from "@mui/icons-material/Explore";
import StorageIcon from '@mui/icons-material/Storage';
// import FlagIcon from "@mui/icons-material/Flag";
// import SupportIcon from "@mui/icons-material/Support";
import "./Style.css";

// Feature Data
const features = [
  {
    icon: <CurrencyExchangeIcon className="feature-icon" />,
    title: "$50M+",
    description:
      "Annual Turnover",
  },
  {
    icon: <StorageIcon className="feature-icon" />,
    title: "25000+",
    description:
      "Bookings Processed Annually",
  },
  {
    icon: <ExploreIcon className="feature-icon" />,
    title: "10000+",
    description: "Passengers Served Worldwide",
  },
  {
    icon: <AirplanemodeActiveIcon className="feature-icon" />,
    title: "80+",
    description: "Expert Travel Advisors",
  },
  // {
  //   icon: <ApartmentIcon className="feature-icon" />,
  //   title: "2",
  //   description: "Global Offices",
  // },
];

function WhyBest() {
  return (
    <section className="why-section" id="Why_We">
      <Container className="why-container">
        {/* <Typography variant="h4" className="why-title">
          Why We Are The Best
        </Typography>
        <Typography variant="subtitle1" className="why-subtitle">
          We provide world-class services and ensure the best travel experience.
        </Typography> */}
        <Grid container spacing={4} justifyContent="center">
          {features.map(function (feature, index) {
            return (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Box className="feature-box">
                  {feature.icon}
                  <Typography variant="h4" className="feature-title">
                    {feature.title}
                  </Typography>
                  <Typography variant="body1" className="feature-description">
                    {feature.description}
                  </Typography>
                  {/* <Typography variant="body2" className="feature-read-more">
                    Read More &gt;
                  </Typography> */}
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </section>
  );
}

export default WhyBest;
